(ns hai.tasks.urgency
  "The task urgency vocabulary: the three `:task.urgency/*` lanes, the none
   value beside them, and their display labels, shared by every surface that
   sets or groups tasks by urgency.")

(def none
  "No urgency. A value like the lanes, so setting it is a write; and where a
   task has no urgency of its own — a task nobody triaged, or a user with no
   default picked — this is what it reads as."
  :task.urgency/none)

(def lanes
  "Ordered lanes, most-to-least urgent. None is not one of them: it is the
   absence a lane is picked out of."
  [{:value :task.urgency/now   :label "Now"}
   {:value :task.urgency/next  :label "Next"}
   {:value :task.urgency/later :label "Later"}])

(defn none?
  "Whether an urgency value means no urgency: [[none]] itself, or no value at
   all — a task from before none existed carries no `:task/urgency`."
  [urgency]
  (or (nil? urgency) (= none urgency)))

(defn label
  "Display label for one `:task.urgency/*` value."
  [urgency]
  (if (none? urgency)
    "None"
    (some (fn [lane]
            (when (= urgency (:value lane))
              (:label lane)))
          lanes)))
